export default Object.freeze({
  None: 'none',
  AnalyzingContext: 'analyzing-context',
  InternalReasoning: 'internal-reasoning',
  ToolCalling: 'tool-calling',
  IdleBetweenSteps: 'idle-between-steps',
  SynthesizingAnswer: 'synthesizing-answer',
  ErrorHandling: 'error-handling',
  ThinkingThreadTitle: 'thinking-thread-title',
  PreparingTaskRun: 'preparing-task-run',
  DownloadingFile: 'downloading-file',
  ContextRecovery: 'context-recovery',
  ReasoningOutputCommentary: 'reasoning-output-commentary',
  AgentCalling: 'agent-calling',
  TodoPlanCreated: 'todo-plan-created',
  TodoItemCreated: 'todo-item-created',
  TodoItemCompleted: 'todo-item-completed',
  PreparingFileResources: 'preparing-file-resources',
  OrchestratingRouting: 'orchestrating-routing',
  DownloadingMedia: 'downloading-media',
  TranscribingAudio: 'transcribing-audio',
  ExtractingVideoFrames: 'extracting-video-frames',
  UploadingAiFile: 'uploading-ai-file',
  PreparingModelContext: 'preparing-model-context',
});
